import React from "react";
import styled from "styled-components";
import { FiSearch, FiEye, FiChevronRight, FiChevronLeft } from "react-icons/fi";

const Container = styled.div`
  font-family: 'Geist', sans-serif;
  // background: #f9f9f9;
  padding: 1rem;
  width: 100%;
  margin-top: 0.2rem;
  min-height: 1260px;
`;

const SearchBar = styled.div`
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: 8px;
  padding: 0.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  margin-bottom: 1rem;
  flex: 1;
`;

const SearchInput = styled.input`
  border: none;
  outline: none;
  flex: 1;
  font-size: 1rem;
`;

const SearchHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width : 100%;
  gap: 1rem;
`;

const BackButton = styled.button`
  font-size: 2rem;
  color: #333;
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom : 1rem;
`;


const Dropdown = styled.select`
  width: 100%;
  margin-bottom: 1rem;
  padding: 0.5rem;
  border-radius: 8px;
  border: 1px solid #ccc;
  font-size: 1rem;
  color : #71717A;
`;

const DateButtons = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1rem;
  color : #71717A;
`;

const DateButton = styled.button`
  width : 40%;
  background: #E6E6E6;
  border: none;
  border-radius: 8px;
  padding: 0.5rem;
  font-size: 15px;
  font-family: 'Geist', sans-serif; 
  color : #71717A;
`;

const DateSection = styled.div`
  margin-top: 1rem;
`;

const DateLabel = styled.div`
  font-weight: bold;
  margin-bottom: 0.5rem;
`;

const Card = styled.div`
  background: white;
  border-radius: 8px;
  padding: 0.75rem 1rem;
  // margin-bottom: 0.5rem;
  border : 1px solid #e5e7eb;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const CardInfo = styled.div`
  display: flex;
  flex-direction: column;
  // font-weight: 500;
  color : #111827 ;
`;

const CardName = styled.span`
  font-weight: bold;
`;

const CardTime = styled.span`
  font-size: 0.875rem;
  color: #888;
`;

const CardAmount = styled.span`
  font-weight: 700;
  color : #111827 
`;

const ActionIcons = styled.div`
  display: flex;
  flex-direction: column; 
  align-items: flex-end;
  gap: 4px;

  .petiticons {
  margin-top: 1rem;
    display: flex;
      justify-content: center;
      align-items: center;
      gap: 15px;
      color : #71717A;
  }
`;

const BottomButtons = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 2rem;
`;

const Btn = styled.button`
  width : 30%;
  padding: 0.5rem;
  font-size: 1rem;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  background-color: ${({ primary }) => (primary ? "#009688" : "#E6E6E6")};
  color: ${({ primary }) => (primary ? "white" : "#71717A")};
  margin: 0 0.5rem;
`;

const TransactionDetailsView = ({ onBack }) => {
  return (
    <Container>
      <SearchHeader>
  <BackButton onClick={ onBack }><FiChevronLeft/></BackButton>
  <SearchBar>
    <FiSearch style={{ marginRight: "8px" }} />
    <SearchInput placeholder="Recherche..." />
  </SearchBar>
</SearchHeader>


      <Dropdown>
        <option>Afficher tout</option>
      </Dropdown>

      <DateButtons>
        <DateButton>Date de debut</DateButton>
        <DateButton>Date de debut</DateButton>
      </DateButtons>

      <DateSection>
        <DateLabel>21 Juillet 2025</DateLabel>

        <Card>
          <CardInfo>
            <CardName>EasyTools DIALLO</CardName>
            <CardTime>06:14</CardTime>
          </CardInfo>

          <ActionIcons>
            <CardAmount type="in">+ 2 500 FCFA</CardAmount>
            <div className="petiticons">
              <FiEye size={18} />
              <FiChevronRight size={20} />
            </div>
          </ActionIcons>
        </Card>

        <Card>
          <CardInfo>
            <CardName>Yvone sow</CardName>
            <CardTime>12:14</CardTime>
          </CardInfo>
          <ActionIcons>
            <CardAmount type="out">- 1 200 FCFA</CardAmount>
            <div className="petiticons">
              <FiEye size={18} />
              <FiChevronRight size={20} />
            </div>
          </ActionIcons>
        </Card>

        <Card>
          <CardInfo>
            <CardName>Yvone sow</CardName>
            <CardTime>12:14</CardTime>
          </CardInfo>
          <ActionIcons>
            <CardAmount type="out">- 1 200 FCFA</CardAmount>
            <div className="petiticons">
              <FiEye size={18} />
              <FiChevronRight size={20} />
            </div>
          </ActionIcons>
        </Card>
      </DateSection>

<DateSection>
        <DateLabel>20 Juillet 2025</DateLabel>

        <Card>
          <CardInfo>
            <CardName>EasyTools DIALLO</CardName>
            <CardTime>06:14</CardTime>
          </CardInfo>

          <ActionIcons>
            <CardAmount type="in">+ 2 500 FCFA</CardAmount>
            <div className="petiticons">
              <FiEye size={18} />
              <FiChevronRight size={20} />
            </div>
          </ActionIcons>
        </Card>

        <Card>
          <CardInfo>
            <CardName>Yvone sow</CardName>
            <CardTime>12:14</CardTime>
          </CardInfo>
          <ActionIcons>
            <CardAmount type="out">- 1 200 FCFA</CardAmount>
            <div className="petiticons">
              <FiEye size={18} />
              <FiChevronRight size={20} />
            </div>
          </ActionIcons>
        </Card>

        <Card>
          <CardInfo>
            <CardName>Yvone sow</CardName>
            <CardTime>12:14</CardTime>
          </CardInfo>
          <ActionIcons>
            <CardAmount type="out">- 1 200 FCFA</CardAmount>
            <div className="petiticons">
              <FiEye size={18} />
              <FiChevronRight size={20} />
            </div>
          </ActionIcons>
        </Card>
      </DateSection>
     
<DateSection>
        <DateLabel>20 Juillet 2025</DateLabel>

        <Card>
          <CardInfo>
            <CardName>EasyTools DIALLO</CardName>
            <CardTime>06:14</CardTime>
          </CardInfo>

          <ActionIcons>
            <CardAmount type="in">+ 2 500 FCFA</CardAmount>
            <div className="petiticons">
              <FiEye size={18} />
              <FiChevronRight size={20} />
            </div>
          </ActionIcons>
        </Card>

        <Card>
          <CardInfo>
            <CardName>Yvone sow</CardName>
            <CardTime>12:14</CardTime>
          </CardInfo>
          <ActionIcons>
            <CardAmount type="out">- 1 200 FCFA</CardAmount>
            <div className="petiticons">
              <FiEye size={18} />
              <FiChevronRight size={20} />
            </div>
          </ActionIcons>
        </Card>

        <Card>
          <CardInfo>
            <CardName>Yvone sow</CardName>
            <CardTime>12:14</CardTime>
          </CardInfo>
          <ActionIcons>
            <CardAmount type="out">- 1 200 FCFA</CardAmount>
            <div className="petiticons">
             <FiEye size={18} />
              <FiChevronRight size={20} />
            </div>
          </ActionIcons>
        </Card>
      </DateSection>

      <BottomButtons>
        <Btn>Fermer</Btn>
        <Btn primary>Rechercher</Btn>
      </BottomButtons>
    </Container>
  );
};

export default TransactionDetailsView;
